// extracted by mini-css-extract-plugin
export default {"userInfo":"UserLogin_userInfo__aXmg4","loginDropdown":"UserLogin_loginDropdown__MLZFi"};